<template>
  <div class="header" id="header">
    <div class="header-center">
      <div class="lj_image pull-left">
        <img
          src="../../assets/img/title/微信图片_20210120105912.png"
          class="ljhead"
        />
      </div>

      <ul class="header-root pull-left" ref="headerList">
        <li
          class="pull-left"
          :class="{ active: v.active }"
          v-for="(v, i) in menuList"
          @click="go(v)"
          :key="i"
          style="width:108px"
        >
          {{ v.name }}
          <ul class="header-sub" v-if="v.child&&v.name!='在线预订'">
            <li v-for="(v1, i1) in v.child" :key="i1" @click.stop="go(v1)">
              {{ v1.name }}
            </li>
          </ul>
        </li>

        <div class="pull-left">
          <div class="login" v-if="userdb">
            <img
              src="../../assets/img/search.png"
              class="hover"
              style="width: 18px;height: 18px;margin-right: 6px;position: relative;top: 1px"
              alt=""
              @click="openSearchBox()"
            />
            <el-dropdown :hide-on-click="false">
              <img src="../../assets/img/headeruser.png" alt="" />
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="loginOut"
                  >退出</el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
            <!-- <img src="../../assets/img/headeruser.png" alt=""> -->
            <a href="shop.html#/order">{{ userdb.username }} </a>
          </div>
          <div class="nologin" style="margin-left: 40px" v-else>
            <img
              src="../../assets/img/search.png"
              class="hover"
              style="width: 18px;height: 18px;margin-right: 5px;position: relative;top: 3px"
              alt=""
              @click="openSearchBox()"
            />
            <a class="hover" @click="loginwx()">登录</a>
          </div>
        </div>
      </ul>
    </div>
    <transition name="el-zoom-in-center">
      <div v-show="show" class="transition-box">
        <div class="searchBox">
          <el-input
            placeholder="全网搜索"
            class="i"
            v-model="query"
            style="font-size: 24px !important;"
            @keyup.native.enter="gotoQuery()"
          ></el-input>
          <div class="btn hover" @click="gotoQuery()">
            <img src="../../assets/img/search.png" />
          </div>
        </div>
        <div class="tips">
          <div>全网搜索</div>
          <div>廉江红橙节 | 走进大美橙乡</div>
          <div>美食节 | 廉江文化</div>
          <div>田园寨 | 谢鞋山 | 鹤地银湖 | 樱花公园 ......</div>
        </div>
        <img
          class="close hover"
          src="../../assets/img/close.png"
          @click="show = !show"
        />
      </div>
    </transition>
  </div>
</template>
<script>
import qs from "qs";
import moment from "moment";
import menu from "../../components/common/menu";
export default {
  name: "header1",
  data() {
    return {
      recovery: {
        columnName: "",
        errorDes: "",
        user: "",
        phone: "",
      },
      dialogVisible: false,
      query: null,
      code: null,
      userdb: null,
      menuList: this.$store.state.menuList,
      date: null,
      weather: this.$store.state.weather,
      show: false,
      type: this.$store.state.weather ? this.$store.state.weather.type : "",
      isOverWidth: false,
    };
  },
  components: {
    "v-menu": menu,
  },
  watch: {
    $route: function(newValue) {
      if (newValue.query.code) {
        this.code = newValue.query.code;
        this.getUserInfo();
      }
    },
    isOverWidth: function(v1, v2) {},
  },
  created() {
    this.getUserInfo();
    //   this.getUserId()
    if (!this.weather) {
      this.getWeather1();
    }
    if (!this.menuList) {
      this.getMenus();
    }
    this.userdb = JSON.parse(localStorage.getItem("userdb"));
    this.code = this.$route.query.code;
    if (this.code) {
      this.getUserInfo();
    }
    // this.getMenus();
  },
  mounted() {
    this.$nextTick(() => {
      console.log(this.$refs.headerList, "ref");
      var overWidth = this.$refs.headerList.clientWidth;
    });
  },
  props: {
    bindData: {
      type: Array,
      default: function(value) {
        return value;
      },
    },
    bookActive: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    getWeather1() {
      const that = this;
      AMap.plugin("AMap.Weather", function() {
        //创建天气查询实例
        var weather = new AMap.Weather();

        //执行实时天气信息查询
        weather.getForecast("廉江市", function(err, data) {
          let s = data.forecasts[0];
          console.log(data);
          console.log(s);
          that.weather = {
            type: s.dayWeather,
            low: s.nightTemp + "℃",
            high: s.dayTemp + "℃",
            date:
              s.date.split("-")[0] +
              "年" +
              s.date.split("-")[1] +
              "月" +
              s.date.split("-")[2] +
              "日",
          };
          switch (s.dayWeather) {
            case "多云":
              that.type = "cloud";
              break;
            case "晴":
              that.type = "sun";
              break;
            case "阴":
              c;
              that.type = "yin";
              break;
            case "小雨":
              that.type = "xiaoyu";
              break;
            case "大雨":
              that.type = "dayu";
              break;
            case "雨夹雪":
              that.type = "yjx";
              break;
            case "小雪":
              that.type = "xx";
              break;
            case "阵雨":
              that.type = "zhenyu";
              break;
            default:
              that.type = "sun";
              break;
          }
          that.weather.type = that.type;
          that.$store.commit("setStateWeather", that.weather);
        });
      });
    },
    openSearchBox() {
      this.show = !this.show;
    },
    gotoQuery() {
      var params;
      if (
        this.query.indexOf("！") !== -1 || 
        this.query.indexOf("!") !== -1 ||
        this.query.indexOf("@") !== -1 ||
        this.query.indexOf("#") !== -1 ||
        this.query.indexOf("$") !== -1 ||
        this.query.indexOf("%") !== -1 ||
        this.query.indexOf("^") !== -1 ||
        this.query.indexOf("&") !== -1 ||
        this.query.indexOf("*") !== -1 ||
        this.query.indexOf("(") !== -1 ||
        this.query.indexOf("（") !== -1 ||
        this.query.indexOf("）") !== -1 ||
        this.query.indexOf(")") !== -1 ||
        this.query.indexOf("_") !== -1 ||
        this.query.indexOf("=") !== -1 ||
        this.query.indexOf("+") !== -1 ||
        this.query.indexOf("-") !== -1 ||
        this.query.indexOf("<") !== -1 ||
        this.query.indexOf(">") !== -1 ||
        this.query.indexOf("/") !== -1
      ) {
        this.$message.error("搜不到相关内容,请重新搜索");
        this.query = "";
        return false;
      } else {
        params = { title: this.query };
      }
      let url = `${api}/api/cms/article/list`;
      this.common
        .http({
          methods: "GET",
          url: url,
          params,
        })
        .then((v) => {
          var data = v.data.data.list;
          if (data.length === 0) {
            this.$message.error("搜不到相关内容,请重新搜索");
            this.query = "";
          } else {
            console.log(data);
            this.$store.commit("setQueryResult", data);
            this.$router.push({ path: "queryResult" });
          }
        });
    },
    getWeather() {
      let arr = moment(new Date())
        .format("YYYY-MM-DD")
        .split("-");
      let baseUrl = encodeURIComponent(
        `https://tianqiapi.com/api?version=v1&appid=46428273&appsecret=9WEyqBuj&cityid=101281005`
      );
      let url = `http://61.163.59.38:8079/yichuan/httptest/doGet?url=${baseUrl}`;
      this.common
        .httpWeahter({
          method: "GET",
          url,
        })
        .then((v) => {
          console.log(v);
          if (v.status > 300) {
            this.weather = {
              type: "晴",
              low: "23℃" + "-",
              high: "32℃",
              date: arr[0] + "年" + arr[1] + "月" + arr[2] + "日",
            };
          } else {
            let data = v.data.data.data[0];
            this.weather = {
              type: data.wea,
              low: data.tem2,
              high: data.tem1,
              date:
                data.date.split("-")[0] +
                "年" +
                data.date.split("-")[1] +
                "月" +
                data.date.split("-")[2] +
                "日",
            };
            switch (data.wea) {
              case "多云":
                this.type = "cloud";
                break;
              case "晴":
                this.type = "sun";
                break;
              case "阴":
                this.type = "yin";
                break;
              case "小雨":
                this.type = "xiaoyu";
                break;
              case "大雨":
                this.type = "dayu";
                break;
              case "雨夹雪":
                this.type = "yjx";
                break;
              case "小雪":
                this.type = "xx";
                break;
              case "阵雨":
                this.type = "zhenyu";
                break;
              default:
                this.type = "sun";
                break;
            }
          }
          this.weather.type = this.type;

          this.$store.commit("setStateWeather", this.weather);
        })
        .catch((v) => {
          this.weather = {
            type: "晴",
            low: "23℃" + "-",
            high: "32℃",
            date: arr[0] + "年" + arr[1] + "月" + arr[2] + "日",
          };
        });
    },
    getUserInfo() {
      let that = this;
      let url = `${apiV2}/third_parties/wechat/login`;
      let param = {
        client_id: "4e17b8ae60040835e1cf9b93ecc60edf",
        client_secret: "secret.1",
        store_identity: storeID,
        app_id: appid,
        app_secret: secrect,
        code: this.code,
      };
      this.common.http.post(url, param).then((v) => {
        let data = v.data.data;
        let userdb = {
          timein: parseInt(Date.parse(new Date())),
          access_token: data.access_token,
          username: data.nickname,
          userId: data.customer_id,
        };
        localStorage.setItem("userdb", JSON.stringify(userdb));
        this.userdb = JSON.parse(localStorage.getItem("userdb"));
        let url = `${api}/api/yuser/saveUser?userid=${this.userdb.userId}&nickname=${this.userdb.username}`;
        this.common.axios.post(url).then((v) => {
          let data = v.data.data;
          let id = data.id;
          localStorage.setItem("id", id);
        });
      });
    },
    loginwx() {
      let redirect_url = encodeURIComponent(location.href);
      let url = `https://open.weixin.qq.com/connect/qrconnect?appid=${appid}&redirect_uri=${redirect_url}&response_type=code&scope=snsapi_login&state=STATE#wechat_redirect`;
      window.open(url);
    },
    go(v) {
      console.log(v, "vvv");
      if (v.aa == "jiucuo") {
        let arr = window.location.href.split("jiucuo");
        let arr1 = arr[0].split("index");
        let url = `${arr1[0]}/#/gwjc`;
        this.$router.replace(url);
      }
      if (
        v.aa == "http://wpa.qq.com/msgrd?v=3&uin=1420561821&site=qq&menu=yes"
      ) {
        window.open(v.aa);
        return;
      }
      console.log(v);
      // if(v.aa!="./#/xzlm"&&v.code!="门户首页"&&v.name!='官网纠错'){
      //     location.href = `${v.aa}&id=${v.child[0].id}&parent=${v.id}`;
      // }else if(v.code=="门户首页"||v.name=='官网纠错'){
      //         location.href = v.aa
      // }else if(v.aa=="./#/xzlm"){
      //        if(v.parent==null){
      //            location.href = `${v.aa}?id=${v.id}&parent=null`;
      //        }else{
      //            location.href = `${v.aa}?id=${v.id}&parent=${v.parent.id}`;
      // }
      //        }
      if (v.aa == "./#/xzlm" && v.parent == null) {
        location.href = `${v.aa}?id=${v.id}&parent=null`;
        return false;
      }
      if (!v.parent && v.code != "门户首页" && v.name != "官网纠错") {
        location.href = v.aa;
      } else if (v.code == "门户首页" || v.name == "官网纠错") {
        location.href = v.aa;
      } else {
        location.href = `${v.aa}?id=${v.id}&parent=${v.parent.id}`;
      }
    },
    //退出登录
    loginOut() {
      localStorage.removeItem("userdb");
      localStorage.removeItem("id");
      window.location.href = "index.html";
    },
    getMenus() {
      let url = `${api}/api/cms/column/list`;
      this.common.axios.get(url).then((v) => {
        let data = v.data.data;
        let navlist = [];
        for (let i = 0; i < data.length; i++) {
          if (data[i].level == "0") {
            // console.log(data[i]);
            let item = data[i];
            item["child"] = [];
            item["ac"] = false;
            for (let j = 0; j < data.length; j++) {
              if (data[j].parent != null) {
                // console.log();
                if (data[j].parent.id == item.id) {
                  item.child.push(data[j]);
                }
              }
            }
            navlist.push(item);
          }
        }
        for (let i = 0; i < navlist.length; i++) {
          let isChild = navlist[i].child.length > 0 ? true : false;
          let turl = "./#/xzlm";
          switch (navlist[i].name) {
            case "了解廉江":
              //turl = `./details.html?id=${navlist[i].child[0].id}&pid=${navlist[i].id}&aid=8a9d2ba16e01cf0d016e5eabb1b900f5`;
              turl = `./#/list1?ljcode=ljgl&columnId=40288a9d6e91c70a016e91cabebd0006&rootColumnId=40288a9d6e91c70a016e91c787ba0000`;
              break;
            case "虚拟游":
              turl = `./#/vr?ljcode=720&columnId=40288a9d6e91c70a016e91cc6eb5000a&rootColumnId=${navlist[i].id}`;
              break;
            case "玩转廉江":
              turl = `./#/list_wzlj?ljcode=ms&columnId=40288a9d6e91c70a016e91cd018f000b&rootColumnId=${navlist[i].id}`;
              break;
            case "廉江特色":
              turl = `./#/tyfg?ljcode=tyfg&columnId=40288a9d6e91c70a016e91cecf5a0012&rootColumnId=${navlist[i].id}`;
              break;
            case "互动交流":
              turl = `./#/lygl?ljcode=lygl&columnId=40288a9d6e91c70a016e91cf71920015&rootColumnId=${navlist[i].id}`;
              break;
            case "在线预订":
              turl = `./shop.html#/jqyd?columnId=8a9d2ba16f64df6e016f787d1a71000d&rootColumnId=2c9a4c9b6ea63d8c016ea6409e450001`;
              break;
            case "旅游服务":
              turl = `./#/lyzn?ljcode=lyzn&articleId=8a9d2ba16ec4607c016ec52657500000&columnId=40288a9d6e91c70a016e91d09edb0019&rootColumnId=${navlist[i].id}`;
              break;
            case "门户首页":
              turl = `./`;
          }

          if (isChild) {
            for (let j = 0; j < navlist[i].child.length; j++) {
              //   console.log(navlist[i].child[j]);
              //let curl =`./list.html?id=${navlist[i].child[j].id}&pid=${navlist[i].id}`;
              let data = navlist[i].child[j];
              let curl = "";
              switch (data.code) {
                case "廉江概览":
                  curl = `./#/list1?ljcode=ljgl&columnId=${navlist[i].child[j].id}&rootColumnId=${navlist[i].id}`;
                  break;
                case "廉江动态":
                  curl = `./#/list2?ljcode=ljdt&columnId=${navlist[i].child[j].id}&rootColumnId=${navlist[i].id}`;
                  break;
                case "节庆活动":
                  curl = `./#/jqhd?ljcode=jqhd&columnId=${navlist[i].child[j].id}&rootColumnId=${navlist[i].id}`;
                  break;
                case "音画廉江":
                  curl = `./#/yhlj?ljcode=yhlj&columnId=${navlist[i].child[j].id}&rootColumnId=${navlist[i].id}`;
                  break;
                case "720°全景游览":
                  curl = `./#/vr?ljcode=720&columnId=${navlist[i].child[j].id}&rootColumnId=${navlist[i].id}`;
                  break;
                case "漫游讲解":
                  curl = `./#/myjj?ljcode=myjj&columnId=${navlist[i].child[j].id}&rootColumnId=${navlist[i].id}`;
                  break;
                case "场景切换":
                  curl = `./#/cjqh?ljcode=cjqh&rootColumnId=40288a9d6e91c70a016e91c895ae0001&columnId=cjqh`;
                  break;
                case "美食":
                  curl = `./#/list_wzlj?ljcode=ms&columnId=${navlist[i].child[j].id}&rootColumnId=${navlist[i].id}`;
                  break;
                case "住宿":
                  curl = `./#/list_wzlj_zs?ljcode=zs&columnId=${navlist[i].child[j].id}&rootColumnId=${navlist[i].id}`;
                  break;
                case "出行":
                  curl = `./#/list_wzlj_cx?ljcode=cx&columnId=${navlist[i].child[j].id}&rootColumnId=${navlist[i].id}`;
                  break;
                case "游玩":
                  curl = `./#/list_wzlj_yw?ljcode=yw&columnId=${navlist[i].child[j].id}&rootColumnId=${navlist[i].id}`;
                  break;
                case "购物":
                  curl = `./#/list_wzlj_gw?ljcode=gw&columnId=${navlist[i].child[j].id}&rootColumnId=${navlist[i].id}`;
                  break;
                case "娱乐":
                  curl = `./#/list_wzlj_yl?ljcode=yl&columnId=${navlist[i].child[j].id}&rootColumnId=${navlist[i].id}`;
                  break;
                case "特产":
                  curl = `./#/list_wzlj_tc?ljcode=tc&columnId=${navlist[i].child[j].id}&rootColumnId=${navlist[i].id}`;
                  break;
                case "红色景点":
                  curl = `./#/list_wzlj_jd?ljcode=jd&columnId=${navlist[i].child[j].id}&rootColumnId=${navlist[i].id}`;
                  break;
                case "田园风光":
                  curl = `./#/tyfg?ljcode=tyfg&columnId=${navlist[i].child[j].id}&rootColumnId=${navlist[i].id}`;
                  break;
                case "赏花观鸟":
                  curl = `./#/shgn?ljcode=shgn&columnId=${navlist[i].child[j].id}&rootColumnId=${navlist[i].id}`;
                  break;
                case "美丽乡村":
                  curl = `./#/mlxc?ljcode=mlxc&columnId=${navlist[i].child[j].id}&rootColumnId=${navlist[i].id}`;
                  break;
                case "景区预订":
                  curl = `./shop.html#/jqyd?columnId=${navlist[i].child[j].id}&rootColumnId=${navlist[i].id}`;
                  break;
                case "酒店预订":
                  curl = `./shop.html#/jdyd?columnId=${navlist[i].child[j].id}&rootColumnId=${navlist[i].id}`;
                  break;
                case "线路预订":
                  curl = `./shop.html#/xlyd?columnId=${navlist[i].child[j].id}&rootColumnId=${navlist[i].id}`;
                  break;
                case "旅游攻略":
                  curl = `./#/lygl?ljcode=lygl&columnId=${navlist[i].child[j].id}&rootColumnId=${navlist[i].id}`;
                  break;
                case "游记分享":
                  curl = `./#/yjfx?ljcode=yjfx&columnId=${navlist[i].child[j].id}&rootColumnId=${navlist[i].id}`;
                  break;
                case "行程规划":
                  curl = `./#/xcgh?ljcode=xcgh&columnId=${navlist[i].child[j].id}&rootColumnId=${navlist[i].id}`;
                  break;
                case "旅游线路":
                  curl = `./#/lyxl?ljcode=lyxl&columnId=${navlist[i].child[j].id}&rootColumnId=${navlist[i].id}`;
                  break;
                case "天气预报":
                  curl = `./#/tqyb?ljcode=tqyb&columnId=${navlist[i].child[j].id}&rootColumnId=${navlist[i].id}`;
                  break;
                case "投诉建议":
                  curl = `./#/tsjy?ljcode=tsjy&columnId=${navlist[i].child[j].id}&rootColumnId=${navlist[i].id}`;
                  break;
                case "旅游指南":
                  curl = `./#/lyzn?ljcode=lyzn&articleId=8a9d2ba16ec4607c016ec52657500000&columnId=${navlist[i].child[j].id}&rootColumnId=${navlist[i].id}`;
                  break;
                case "旅游电话":
                  curl = `./#/lydh?ljcode=lydh&articleId=8a9d2ba16e01cf0d016e64426677010b&columnId=${navlist[i].child[j].id}&rootColumnId=${navlist[i].id}`;
                  break;
                case "出游宝典":
                  curl = `./#/cybd?ljcode=cybd&articleId=8a9d2ba16e01cf0d016e64728b7a0115&columnId=${navlist[i].child[j].id}&rootColumnId=${navlist[i].id}`;
                  break;
                case "常见问题":
                  curl = `./#/cjwt?ljcode=cjwt&articleId=8a9d2ba16ec4607c016ec59b69000005&columnId=${navlist[i].child[j].id}&rootColumnId=${navlist[i].id}`;
                  break;
                case "在线咨询":
                  curl = `http://wpa.qq.com/msgrd?v=3&uin=1420561821&site=qq&menu=yes`;
                  break;
                case "官网纠错":
                  curl = `./#/gwjc`;
                default:
                  curl = `./#/xzlm`;
                  break;
              }
              navlist[i].child[j]["aa"] = curl;
            }
          }

          navlist[i]["aa"] = turl;
        }
        navlist[navlist.length - 1].child.push({
          name: "官网纠错",
          aa: "/#/gwjc",
        });

        this.menuList = navlist;
        console.log(this.menuList, "menuList");
        this.$store.commit("setStateMenuList", this.menuList);
        // localStorage.setItem("menuList",JSON.stringify(this.menuList));
      });
    },
  },
};
</script>
<style lang="less" scoped>
.header {
  height: 80px;
  background-color: rgba(0, 0, 0, 0.4);
  font-size: 18px;
  color: #fff;
  position: absolute;
  top: 0;
  width: 100%;
  min-width: 1800px;
  z-index: 999;
  opacity: 0.9;
  &-center {
    width: 1400px;
    margin: 0 auto;
    height: 80px;
  }

  .login {
    display: flex;
    align-items: center;
    line-height: 80px;

    img {
      position: relative;
      top: 10px;
      margin-right: 10px;
    }

    a {
      display: inline-block;
      position: relative;
      cursor: pointer;
      //    width: 48px;
      //     color: #666;
      height: 30px;
      padding: 0 15px;
      line-height: 30px;
      background-color: #eee;
      border-radius: 15px;
    }
  }

  .nologin {
    line-height: 80px;

    a {
      font-size: 18px;
      //  font-weight: 600;
      margin-right: 10px;
      color: #fff;
    }
  }

  &-sub {
    position: absolute;
    display: none;
    background: rgba(0, 0, 0, 0.5);
    width: 100%;
    z-index: 100;

    > li {
      line-height: 40px;
      color: #fff;
      border-bottom: 1px solid #fff;
      font-size: 14px;

      &:hover {
        background: rgba(0, 0, 0, 0.6);
      }
    }
  }
  .lj_image {
    height: 80px;
    // width: 400px;
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-right: 32px;
    .right {
      padding-top: 10px;
      font-size: 14px;
      .up {
        height: 40px;
        display: flex;
        align-items: center;
      }
      .down {
        height: 40px;
      }
    }
    .ljhead {
      height: 40px;
      position: relative;
      top: -5px;
      margin-right: 35px;
    }
  }

  &-root {
    > li {
      width: 95px;
      line-height: 80px;
      //    color: #333;
      text-align: center;
      cursor: pointer;
      position: relative;

      &:hover {
        background-color: rgba(0, 0, 0, 0.3);
        color: rgba(255, 255, 255);
        display: block;
      }

      &:hover .header-sub {
        display: block;
        > li {
          background-color: rgba(0, 0, 0, 0.3) !important;
          border: none;
        }
      }
      &:hover .header-sub {
        border-top: 5px solid #ffd54f;
      }

      &.active {
        background: url("../../assets/img/navbg.png") no-repeat;
        background-size: 100% 100%;
        color: #fff;
      }
    }
  }
}

/*适应宽度*/
// @media screen and (max-width: 1300px) {
//     .header{
//         &-center {
//             width: 1200px;
//             margin: 0 auto;
//             height: 80px;
//         }
//     }
// }
</style>
